import {
  validateEmail,
  validatePhoneNumber,
  validateTaxId,
  validateZipCode,
  validateAveragePurchase
} from 'utils/formatUtils'

export type FormValues = {
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
  faxNumber: string
  companyName: string
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  zipCode: string
  source: string
  businessType: string
  currentSupplier: string
  averagePurchase: string
  services: string[]
  taxId: string
}

type FormErrors = { [key: string]: boolean }

export const validateSignUpStep = (
  step: number,
  formValues: FormValues
): FormErrors => {
  const stepErrors: FormErrors = {}

  if (step === 1) {
    if (!validateEmail(formValues.email)) stepErrors.email = true
    if (formValues.firstName.trim() === '') stepErrors.firstName = true
    if (formValues.lastName.trim() === '') stepErrors.lastName = true
    if (!validatePhoneNumber(formValues.phoneNumber))
      stepErrors.phoneNumber = true
    if (
      formValues.faxNumber.trim() !== '' &&
      !validatePhoneNumber(formValues.faxNumber)
    )
      stepErrors.faxNumber = true
    if (formValues.companyName.trim() === '') stepErrors.companyName = true
    if (formValues.taxId.trim() === '' || !validateTaxId(formValues.taxId))
      stepErrors.taxId = true
    if (formValues.addressLine1.trim() === '') stepErrors.addressLine1 = true
    if (formValues.city.trim() === '') stepErrors.city = true
    if (formValues.state.trim() === '') stepErrors.state = true
    if (!validateZipCode(formValues.zipCode)) stepErrors.zipCode = true
  } else if (step === 2) {
    if (formValues.currentSupplier.trim() === '')
      stepErrors.currentSupplier = true
    if (!validateAveragePurchase(formValues.averagePurchase))
      stepErrors.averagePurchase = true
    if (formValues.services.length === 0) stepErrors.services = true
    if (formValues.source.trim() === '') stepErrors.source = true
    if (formValues.businessType.trim() === '') stepErrors.businessType = true
  }

  return stepErrors
}
